import axios from "axios";
import { URL_PackageClientHistory, URL_PackageProcedure } from "../components/Services/PackageService";

let cache = [];


/**
 * @description Ferramenta auxiliar para manipulação do sistema de pacotes;
 */
export default class PackageHandler {
    static async forceBalance() {
        const resp = await axios.get(`${URL_PackageProcedure}/balance`);
    }

    async getAllPCHByIdClient(idClient) {
        return new Promise((res, rej) => {
            let now = new Date();
            if (cache[idClient] && cache[idClient].time - now < 1000) {
                if (cache[idClient].data)
                    res(cache[idClient].data);
                else
                    res(cache[idClient].promise)
            } else {
                let promise = axios.get(`${URL_PackageClientHistory}/GetByIdClient/${idClient}`);
                cache[idClient] = {
                    time: new Date(),
                    promise
                }
                promise.then(resp => {
                    const { data } = resp;
                    cache[idClient] = {
                        time: new Date(),
                        promise,
                        data
                    }
                    res(data);
                });
            }
        });
        // if (cache[idClient]) {
        //     let sm = cache[idClient];
        //     let data = sm.data;
        //     if (data)
        //         return data;
        //     else
        //         return (await axios.get(`${URL_PackageClientHistory}/GetByIdClient/${idClient}`)).data;
        // } else {
        //     let sm = new SmallCache();
        //     cache[idClient] = sm;
        //     debugger;
        //     sm.data = (await axios.get(`${URL_PackageClientHistory}/GetByIdClient/${idClient}`)).data;
        //     return sm.data;
        // }
        // return (await axios.get(`${URL_PackageClientHistory}/GetByIdClient/${idClient}`)).data;
    }
    /**
     * @param {number} idClient 
     * @returns Retorna um Array[idPackageProcedure] de type == OperationType.reveneue cuja propriedade value significa o saldo disponível do usuário, bem como o valor amount nos procedimentos significam o valor de cotas disponíveis;
     */
    async getAvailableProceduresByIdClient(idClient) {
        let result = (await axios.get(`${URL_PackageClientHistory}/${idClient}/balance`)).data;
        let ret = [];
        let keys = Object.keys(result);
        keys.forEach(key => {
            let _keys = Object.keys(result[key]);
            ret[key] = [];
            _keys.forEach(_key => {
                ret[key][_key] = result[key][_key];
            });
        });
        return ret;
    }
}